export default __webpack_public_path__ + "static/media/megaphone-icon-white.ee8fbb87.png";